import { CrossOriginCommunication } from '../../../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { Logger } from '../../../logger/Logger';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import type { GameCommunicationErrorMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface ThirdPartyErrorMessage extends GameCommunicationErrorMessageType {
  error: string;
  id: string;
  type: string;
  user_id: string;
  value: string;
}

export class CoreThirdPartyErrorGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.ThirdPartyError;

  public process(message: ThirdPartyErrorMessage): void {
    const errorCode = message.optExtErrorCode;
    const errorMessage = message.optExtErrorMsg;
    const { category, severity } = message;

    CrossOriginCommunication.dispatchWithDebounce(OutgoingMessage.ErrorMessage, {
      errorCode,
      errorMessage,
      errorParameters: {
        category,
        severity,
      },
    });

    Logger.logFailure('gameCommunicationError', {
      place: 'GameCommunicationThirdPartyErrorProcessor',
      additional: errorCode?.toString(),
    });
  }
}
